import apiClient from './apiClient';

export const authenticateUser = async (email, password) => {
  try {
    const response = await apiClient.post('/auth.php?action=login', {
      email,
      password,
    });

    if (response.data.success) {
      return response.data;
    }

    return null;
  } catch (error) {
    console.error('Errore durante l\'autenticazione:', error);
    throw error;
  }
}